import { render, staticRenderFns } from "./AtomRequestOfferButton.vue?vue&type=template&id=42f39598&scoped=true&"
import script from "./AtomRequestOfferButton.vue?vue&type=script&lang=js&"
export * from "./AtomRequestOfferButton.vue?vue&type=script&lang=js&"
import style0 from "./AtomRequestOfferButton.vue?vue&type=style&index=0&id=42f39598&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f39598",
  null
  
)

/* custom blocks */
import block0 from "@/lang/AtomRequestOfferButton.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fatoms%2Fproject%2Fbuilding%2FAtomRequestOfferButton.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports